<!-- HotX Console 0.1.121 域名管理默认首页。实际修改时间：2026-09-29 13:25:25 CST；精确父基线：2b265b8475709018e4bf7099ec6a081871eb4c6b；变更：CONSOLE-HOME-DATA-PASSWORD-20260929。 -->
<template>
  <section class="page">
    <div class="page-title">
      <h1>页面不存在</h1>
      <p>当前路由不存在，可能是地址已变更或入口已下线。</p>
    </div>
    <RouterLink to="/domains" class="return-home-link" aria-label="返回控制台首页">
      返回控制台首页
    </RouterLink>
  </section>
</template>
